module.exports = __webpack_public_path__ + "img/chicken.785fd840.png";